import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  FormerEmployer,
  JobDetails,
  FooterSection,
  FormerSupervisor
} from "component-library/employee-profile/resume/EmploymentHistory";
import * as FIELDS from "component-library/employee-profile/resume/utils/Constants";
import { Verification } from "component-library/employee-profile/resume/Components";
import * as util from "app/common/utilities";
import {
  editEntityData,
  clearEntityData
} from "app/common/reducers/entityData";
import {
  clearEntityErrors,
  editEntityErrors
} from "app/common/reducers/entityErrors";
import Toaster from "component-library/toasters/index";

class AddEmploymentHistory extends Component {
  state = {
    toasterMessage: "",
    showToaster: false,
    toasterClass: "",
    showCloseIcon: true
  };

  componentDidMount() {
    const { EmploymentHistoryId } = this.props.match.params;
    const { resumeEntityData = {} } = this.props;
    if (
      !util.isUndefinedOrZero(EmploymentHistoryId) &&
      Object.keys(resumeEntityData).length !== 0
    ) {
      this.props.fetchAndSetEmploymentHistory(
        parseInt(EmploymentHistoryId, 10),
        resumeEntityData
      );
    }
    this.props.toggleAddOnMode(true);
    this.props.loadStateList();
    this.props.loadCountryList();
  }

  componentDidUpdate(prevProps, prevState) {
    const { EmploymentHistoryId } = this.props.match.params;
    const prevEmploymentHistoryId = prevProps.match.params.EmploymentHistoryId;
    if (
      (prevEmploymentHistoryId !== EmploymentHistoryId ||
        this.props.resumeEntityData !== prevProps.resumeEntityData) &&
      Object.keys(this.props.resumeEntityData).length !== 0 &&
      !util.isUndefinedOrZero(EmploymentHistoryId)
    ) {
      this.props.fetchAndSetEmploymentHistory(
        parseInt(EmploymentHistoryId, 10),
        this.props.resumeEntityData
      );
    }
    if (
      this.props.editMode &&
      this.props.data !== prevProps.data &&
      Object.keys(this.props.data).length > 0
    ) {
      if (this.props.data[FIELDS.IS_VERIFIED]) {
        let toasterMessage = `You're updating a previously-verified employment history. Please update the verification section if necessary.`;
        //this.props.setToaster(toasterMessage, "warning", false);
        this.setState({
          showToaster: true,
          toasterMessage: toasterMessage,
          toasterClass: "warning",
          showCloseIcon: false
        });
      }
    }
  }

  onChange = e => {
    const { editData, editErrors } = this.props;
    const edits = { [e.name]: e.value };
    const errors = { [e.name]: null };

    if (e.name === FIELDS.DIFFERENT_NAME || e.name === FIELDS.IS_VERIFIED) {
      edits[e.name] = e.value === "true" ? true : false;
    }

    editData(edits);
    editErrors(errors);
  };

  getFromToValue = e => {
    const { editData } = this.props;
    const edits = { [e.name]: e.value };
    editData(edits);
  };

  onAddClick = () => {
    const {
      saveEmploymentHistoryRecordAndReload,
      setToaster,
      employeeName,
      data,
      onCancelClick
    } = this.props;
    saveEmploymentHistoryRecordAndReload(data, employeeName, toasterMessage => {
      setToaster(toasterMessage, "success");
      onCancelClick();
    });
  };

  update = id => {
    const {
      updateEmploymentHistoryRecordAndReload,
      setToaster,
      employeeName,
      data,
      onCancelClick
    } = this.props;
    updateEmploymentHistoryRecordAndReload(
      id,
      data,
      employeeName,
      toasterMessage => {
        setToaster(toasterMessage, "success");
        onCancelClick();
      }
    );
  };

  toggleToaster = () => {
    this.setState({
      showToaster: false
    });
  };

  componentWillUnmount() {
    this.props.clearData();
    this.props.clearErrors();
    this.props.onCancelClick();
    this.props.toggleToaster();
    this.props.toggleAddOnMode(false);
  }

  render() {
    const {
      data = {},
      errors,
      onCancelClick,
      stateList = [],
      editMode,
      getFromToValue
    } = this.props;
    let states = stateList.length > 0 ? stateList : [];
    return (
      <div className="tab-container-add-section">
        <div id="add-employment-history" className="title-band-container">
          <div className="title-band">
            {editMode ? "Edit Employment History" : "Add Employment History"}
          </div>
        </div>
        <Toaster
          id={"employmentHistoryToaster"}
          show={this.state.showToaster}
          alertClassName={this.state.toasterClass}
          message={this.state.toasterMessage}
          closeToasterMessage={this.toggleToaster}
          showCloseIcon={this.state.showCloseIcon}
        />
        <FormerEmployer
          stateList={states}
          data={data}
          onChange={this.onChange}
          errors={errors}
        />
        <JobDetails data={data} onChange={this.onChange} errors={errors} />

        <FormerSupervisor
          data={data}
          onChange={this.onChange}
          errors={errors}
        />

        <Verification
          data={data}
          onChange={this.onChange}
          getFromToValue={getFromToValue}
          errors={errors}
        />
        <FooterSection
          onAddClick={this.onAddClick}
          onCancelClick={onCancelClick}
          editMode={editMode}
          update={this.update}
        />
      </div>
    );
  }
}
const stateToProps = state => {
  const { entitySetup } = state.common;
  const { data, errors = {} } = entitySetup;
  return {
    data,
    errors,
    stateList: state.common.countryState.States,
    countryList: state.common.country.Countries
  };
};

const actionCreators = {
  editData: editEntityData,
  clearData: clearEntityData,
  clearErrors: clearEntityErrors,
  editErrors: editEntityErrors
};

export default withRouter(
  connect(stateToProps, actionCreators)(AddEmploymentHistory)
);
